import React from "react";
import { SectionCta } from "../SectionCta";
import { images } from "../../data/content";
export function Author() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-69" data-mp="1ht3thgky4c62">
      <div className="mx-auto grid max-w-6xl items-start gap-10 lg:grid-cols-[400px_1fr] lg:gap-16" data-id="element-70" data-mp="1wh6zgpyznnuv">
        <div className="lg:sticky lg:top-8" data-id="element-71" data-mp="1rpf4m38suvyx">
          <img src={images.author} alt="Dr. Ryan Carter" className="mx-auto aspect-[4/5] w-full max-w-md rounded-3xl object-cover" loading="lazy" data-id="element-72" data-mp="1ronm9u47quql" />
        </div>

        <div data-id="element-73" data-mp="20kmqn6sagw06">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand sm:text-sm" data-id="element-74" data-mp="2ff9h2jp7iiin">Meet the author</p>
          <h2 className="mt-3 font-display text-[34px] font-black leading-[1.05] tracking-tight text-ink sm:text-5xl" data-id="element-75" data-mp="2afwwk5lt5nj8">
            Dr. Ryan Carter
          </h2>
          <p className="mt-2 font-display text-xl font-bold text-cta" data-id="element-76" data-mp="l3me29w5vbr6">Why I Created Musculoskeletal Clinical Pathway™</p>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink/85" data-id="element-77" data-mp="3gemgrelnwuc1">
            <p data-id="element-78" data-mp="3gcjg80mvvit2">
              I’ve always believed that good clinical practice involves more than knowing individual tests or memorizing lists
              of conditions.
            </p>
            <p data-id="element-79" data-mp="3pcy3v6nbl9zq">
              It also involves knowing how to organize information, recognize when something doesn’t fit the expected
              presentation, and understand when additional evaluation is needed.
            </p>
            <p data-id="element-80" data-mp="7yatvaayfo9c">
              Musculoskeletal assessment can involve a considerable amount of information. Symptoms overlap, examination
              findings require interpretation, and no single test can answer every clinical question.
            </p>
            <p data-id="element-81" data-mp="gypl0qalnxkr">
              That’s why I developed the Musculoskeletal Clinical Pathway™. I wanted to bring important assessment concepts
              together in a structured collection that professionals could use to support their learning and review their
              clinical reasoning.
            </p>
            <p data-id="element-82" data-mp="3m3m430ubtyog">
              The six volumes cover the initial assessment, red flags, regional examination, clinical reasoning, differential
              assessment, and educational cases. The five accompanying resources provide additional ways to organize and
              review that information.
            </p>
            <p className="rounded-2xl border-l-4 border-cta bg-paper p-5 font-medium text-ink" data-id="element-83" data-mp="8uzvaxlpr7c7">
              My goal is straightforward: to help you approach musculoskeletal assessment with a clearer framework,
              better-organized information, and a more deliberate reasoning process.
            </p>
            <p data-id="element-84" data-mp="dlyf475wunk7">I designed this collection to complement your existing education and experience, not replace them.</p>
          </div>

          <div className="mt-6" data-id="element-85" data-mp="rmiu0s8pfz8f">
            <p className="font-display text-xl font-extrabold text-ink" data-id="element-86" data-mp="rjd7nkrgnbge">Dr. Ryan Carter</p>
            <p className="text-sm font-medium text-muted" data-id="element-87" data-mp="mo7lcku5burs">Creator of Musculoskeletal Clinical Pathway™</p>
          </div>

          <div className="lg:[&>div]:items-start lg:[&>div]:text-left" data-id="element-88" data-mp="166bt8z3mzbn7">
            <SectionCta label="Learn With Dr. Carter’s Framework" data-id="element-89" data-mp="1b6hrwz8bpyes" />
          </div>
        </div>
      </div>
    </section>;
}